"use client";

import { useTranslation } from "react-i18next";
import { useState } from "react";

const languages = [
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "pt", name: "Português", flag: "🇧🇷" },
  { code: "es", name: "Español", flag: "🇪🇸" },
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const currentLanguage =
    languages.find((lang) => lang.code === i18n.language) || languages[0];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="language-selector">
      <button
        className="language-selector__button"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Select language"
      >
        <span className="language-selector__flag">{currentLanguage.code}</span>
        <span className="language-selector__arrow">▼</span>
      </button>

      {isOpen && (
        <div className="language-selector__dropdown">
          {languages.map((language) => (
            <button
              key={language.code}
              className={`language-selector__option ${
                i18n.language === language.code
                  ? "language-selector__option--active"
                  : ""
              }`}
              onClick={() => changeLanguage(language.code)}
            >
              {/* <span className="language-selector__option-flag">
                {language.flag}
              </span> */}
              <span className="language-selector__option-name">
                {language.name}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
